// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Pwbwn","defaultLoaderImage":"Loader_defaultLoaderImage__PblJk"};